
export default {
    namespaced: true,
    state: {
        dialog: false,
        usuario: {},
        usuarios: [],
        gruposUsuario: [],
        color: '',
        editandoUsuario: ''
    },
    mutations: {
        SET_DIALOG(state, mostrar){
            state.dialog = mostrar
        },
        SET_USUARIOS(state, respuesta){
            state.usuarios = [];
            let usuarios = [];
            respuesta.data.forEach(usuario => {
                let estado = usuario.habilitado ? 'Habilitado' : 'Deshabilitado';
                usuarios.push({
                    id: usuario.id,
                    nombre: usuario.name,
                    apellidos: usuario.apellidos,
                    email: usuario.email,
                    fechaCreacion: usuario.created_at,
                    habilitado: usuario.habilitado,
                    telefono: usuario.telefono,
                    observaciones: usuario.observaciones,
                    estado: estado
                });
            });
            state.usuarios = usuarios;
        },
        SET_USUARIO(state, usuario){
            state.usuario = usuario;
            // state.usuario.name = usuario.name;
            // state.usuario.apellidos = usuario.apellidos;
            // state.usuario.avatar = usuario.avatar;
            // state.usuario.color = usuario.color;
            // state.usuario.telefono = usuario.telefono;
            // state.usuario.habilitado = usuario.habilitado;
            // state.usuario.observaciones = usuario.observaciones;
            // state.usuario.idTipoUsuario = usuario.idTipoUsuario;
            state.usuario.gruposAsignados = []; // Vacío el array cada vez que entro para evitar que se dupliquen valores al volver a entrar por el push
            // Recorro el listado de grupos obtenidos por la API para quedarme únicamente con el id
            usuario.grupos.forEach(element => 
                state.usuario.gruposAsignados.push(element.id)
            );
            state.editandoUsuario = true;
            //console.log(state.usuario);
            // FIN
        },
        SET_NUEVOUSUARIO(state){
            state.editandoUsuario = false;
            let colores = ['teal', 'pink darken-1', 'purple darken-1', 'deep-purple darken-1', 'indigo darken-1', 'blue darken-1', 'light-blue darken-1', 'cyan darken-1', 'teal', 'green darken-1', 'orange darken-1', 'brown darken-1', 'blue-grey darken-1', 'red darken-1'];
            state.usuario = {
                name: '',
                apellidos: '',
                email: '',
                password: '',
                telefono: '',
                avatar: 'NU',
                color: colores[Math.floor(Math.random() * colores.length)],
                habilitado: 1,
                observaciones: '',
                idTipoUsuario: '',
                gruposAsignados: [],
                habilitado: 1
            }
        },
        // SET_NOMBRE(state, nombreNuevo){
        //     state.usuario.nombre = nombreNuevo
        // },
        // SET_APELLIDOS(state, apellidosNuevo){
        //     state.usuario.apellidos = apellidosNuevo
        // },
        // SET_TELEFONO(state, telefonoNuevo){
        //     state.usuario.telefono = telefonoNuevo
        // },
        // SET_HABILITADO(state, habilitado){
        //     state.usuario.habilitado = habilitado
        // },
        // SET_OBSERVACIONES(state, observacionesNuevo){
        //     state.usuario.observaciones = observacionesNuevo
        // },
        SET_GRUPOSUSUARIO(state, grupos){
            //console.log(grupos);
            state.gruposUsuario = grupos;
        },
        
    },
    actions: {
        setDialog({commit}, mostrar){
            commit('SET_DIALOG', mostrar);
        },
        setUsuario({commit}, usuario){
            commit('SET_USUARIO', usuario);
        },
        setUsuarios({commit}, respuesta){
            commit('SET_USUARIOS', respuesta);
        },
        setNuevoUsuario({commit}){
            commit('SET_NUEVOUSUARIO');
        },
        setGruposUsuario({commit}, grupos){
            commit('SET_GRUPOSUSUARIO', grupos);
        }
    }
}